<template>
    <transition :name="transition">
        <div id="we-are-moving" class="snackbar message" v-if="messageVisible">
            <div class="message-header">
                {{ newMessage.header }}
                <button @click="messageVisible=false" class="delete"></button>
            </div>
            <div class="message-body" v-html="newMessage.body" />
        </div>
    </transition>
</template>

<script>
import {mapGetters} from "vuex";
import {viewports} from "../../store/constants/viewports";
export default {
    name: "SnackbarInfo",
    data() {
        return {
            messageVisible: true,
            newMessage: {
                type: "warning",
                header: this.$t("notifications.holiday_leave.header"),
                body: this.$t("notifications.holiday_leave.body")
            }
        }
    },
    computed: {
        ...mapGetters(["screenSize", "currentViewport"]),
        transition() {
            if ([viewports.MOBILE.name, viewports.TABLET.name].includes(this.currentViewport)) {
                return "snackbar-mobile"
            } else {
                return "snackbar"
            }
        }
    },
}
</script>
<style scoped lang="scss">
#we-are-moving {
    max-width: 580px;
    left: 1rem;
    .message-header {
        background-color: #0ea983;
    }

    .message-body .text-highlight {
        color: red;
    }
    .text-highlight {
        text-decoration: underline; font-weight: 700;
    }
}

</style>
